// extracted by mini-css-extract-plugin
module.exports = {"text":"SectionHeader-module--text--2a9489"};